module.exports = __webpack_public_path__ + "static/media/normal.adaaeea3.svg";